import React, { useState, useEffect } from 'react';
import DeploymentsTable from "../components/DeploymentsTable";
import { FormMode } from '../../../../types/formMode';
import Grid from '@mui/material/Grid';
import DeploymentRerunDialog from '../components/DeploymentRerunDialog';
import DeploymentApi from '../../../../api/deploymentApi';
import { useDeploymentList } from '../../../../hooks/useDeploymentList';
import { AppErrorList, useAppErrorList } from '../../../../shared/components/AppErrorList';

interface DialogOptions {
  readonly isOpen: boolean;
  readonly deploymentId: string;
}

const INITIAL_DIALOG_OPTIONS: DialogOptions = {
  isOpen: false,
  deploymentId: '',
};

type Props = {
  readonly showDeploymentForm: (mode: FormMode, id: string) => void;
}

const ViewDeploymentsTableContainer = (props: Props) => {
  const { showDeploymentForm } = props;

  const [{ deployments, isLoading, errors: loadingDeploymentsError }, { refreshAll }] = useDeploymentList();
  const [{ errors, hasErrors }, { addError, setErrors }] = useAppErrorList();
  const [dialogOptions, setDialogOptions] = useState<DialogOptions>(INITIAL_DIALOG_OPTIONS);

  const openDialog = (deploymentId: string) => setDialogOptions({ isOpen: true, deploymentId });
  const closeDialog = () => setDialogOptions(INITIAL_DIALOG_OPTIONS);

  const handleRerunDeployment = (deploymentId: string) => {
    DeploymentApi.rerunDeployment(deploymentId)
      .then(() => {
        closeDialog();
        refreshAll();
      })
      .catch(addError);
  };

  useEffect(() => {
    setErrors(loadingDeploymentsError);
  }, [setErrors, loadingDeploymentsError]);

  return (
    <>
      {hasErrors && (
        <Grid item md={12}>
          <AppErrorList errors={errors} />
        </Grid>
      )}

      <DeploymentsTable
        deployments={deployments}
        isLoading={isLoading}
        onViewClick={id => showDeploymentForm(FormMode.VIEW, id)}
        onRerunClick={openDialog}
      />
      <DeploymentRerunDialog
        isOpen={dialogOptions.isOpen}
        deploymentId={dialogOptions.deploymentId}
        onConfirmClick={() => handleRerunDeployment(dialogOptions.deploymentId)}
        onCancelClick={closeDialog}
      />
    </>
  )
}

export default ViewDeploymentsTableContainer;
